// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badge {
  padding: 3px 8px 3px 8px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  border: 1.5px solid #333333;
  border-radius: 50px;
}

.badge2 {
  padding: 3px 8px 3px 8px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #E47C77;
  border: 1px solid #E47C77;
  border-radius: 50px;
}`, "",{"version":3,"sources":["webpack://./src/common/badge/badge.scss"],"names":[],"mappings":"AAAA;EACI,wBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,2BAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,wBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,yBAAA;EACA,mBAAA;AADJ","sourcesContent":[".badge {\n    padding: 3px 8px 3px 8px;\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 20px;\n    color: #333333;\n\n    border: 1.5px solid #333333;\n    border-radius: 50px;\n}\n\n.badge2 {\n    padding: 3px 8px 3px 8px;\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 20px;\n    color: #E47C77;\n\n    border: 1px solid #E47C77;\n    border-radius: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
